import { Container, Divider } from '@mui/material';

const LeadershipHeader = () => {
  return (
    <Container sx={{ pt: 2 }}>
      <h3 style={{ fontFamily: 'SF Pro Display' }}>Nexusar Leadership</h3>
      <Divider sx={{ pt: 1 }} />
    </Container>
  );
};

export default LeadershipHeader;
